import React from "react";
import SelectInput from "./SelectInput";

const ChipInputSelect = React.forwardRef((props, ref) => {
  const {
    id,
    label,
    options,
    freeSolo = false,
    name,
    onInputChange,
    onChange,
    onFocus,
    onBlur,
    blurOnSelect = true,
    disableCloseOnSelect = false,
    filterSelectedOptions = true,
    isOptionEqualToValue,
    value,
    size = "auto",
    multiple = true,
    markers,
    limitTags = 50,
    getOptionLabel,
    disabled = false,
    renderOption,
    renderGroup,
    groupBy,
    openOnFocus = false,
  } = props;
  return (
    <SelectInput
      markers={markers}
      label={label}
      groupBy={groupBy}
      id={id}
      name={name}
      ref={ref}
      value={value}
      options={options}
      multiple={multiple}
      freeSolo={freeSolo}
      filterSelectedOptions={filterSelectedOptions}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      onInputChange={onInputChange}
      size={size}
      blurOnSelect={blurOnSelect}
      onFocus={onFocus}
      onBlur={onBlur}
      disableCloseOnSelect={disableCloseOnSelect}
      isOptionEqualToValue={isOptionEqualToValue}
      limitTags={limitTags}
      disabled={disabled}
      renderGroup={renderGroup}
      renderOption={renderOption}
      openOnFocus={openOnFocus}
    />
  );
});

export default ChipInputSelect;
